import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../styles/Navbar.scss"
import logo from "./assets/logo.png";
import {MdMenu } from "react-icons/md";
import NavMenu from "./NavMenu"


const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const MenuIcon = MdMenu as React.ElementType;

  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <Link to="https://gottix.gottit.io/" className="navbar-logo-link">
            <img src={logo} alt="Gottix Logo" />
          </Link>
        </div>
        <div className="navbar-icons">
          <MenuIcon
            className="nav-icon menu-icon"
            size={24}
            onClick={() => setMenuOpen((prev) => !prev)}
          />
        </div>
      </nav>

      {/* <NavMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} /> */}
    </>
  );
};

export default Navbar;
